import { render } from "./Message.vue?vue&type=template&id=2420d42a&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=2420d42a&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod_web_mall_haier_mall/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2420d42a"]])

export default __exports__